import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component LetterFastIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <LetterFastIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <LetterFastIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const LetterFastIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    svgRef?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      data-testid="LetterFastIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="M8 6c-1.1 0-2 .9-2 2v9a2 2 0 002 2h13c1.11 0 2-.89 2-2V8a2 2 0 00-2-2H8zm0 11V9.67L14.5 13 21 9.67V17H8zm0-9h13l-6.5 3.31L8 8zm-4 9.5H1c-.552 0-1-.45-1-1s.448-1 1-1h3c-.013 1.22-.013 1.887 0 2zm0-10c-.013.113-.013.78 0 2H1c-.55 0-1-.45-1-1s.45-1 1-1h3zm-4 5c0-.55.45-1 1-1h3v2H1c-.55 0-1-.45-1-1z"
        clipRule="evenodd"
      />
    </svg>
  )
);
LetterFastIcon.displayName = "LetterFastIcon";
export default LetterFastIcon;
